import QRCode from "../assets/images/qrcode.jpeg";
import AvivaBOMLogo from "../assets/logos/Aviva-BOM.png";
import AvivaLogo from "../assets/logos/aviva.png";
// import BOMLogo from "../assets/logos/bom.png";
import BOMLogo from "../assets/logos/bank-of-maharashtra.png";
import AvivaParivarVikasYojana from "../assets/images/Aviva-Bharat-Parivar-Yojna.jpg";
import Loader from "../assets/images/Aviva-BOM-Loader.jpg";
import AvivaBGBLogo from "../assets/logos/aviva-bgb-logo.jpg";

export const Images = {
  AvivaBOMLogo,
  AvivaBGBLogo,
  AvivaLogo,
  AvivaParivarVikasYojana,
  QRCode,
  BOMLogo,
  Loader,
};
